var _a;
import { useAccountCrumbs } from '@thd-olt-component-react/customer-account-navigation';
import React, { useEffect } from 'react';
import { Typography, Button } from '@one-thd/sui-atomic-components';
import PageLayout from '../components/shared/PageLayout';
import { getWindow } from '../utils/general';
import { getOrderSubscriptionHMAC } from '../api/oms/order-subscriptions';
// Merchant ID for OG
var MERCHANT_ID = '379dc8f09a4311e7806bbc764e106cf4';
// Check domain and set static url
var OG_URL = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.__EXPERIENCE_CONTEXT__.hosts.orderGroove;
export var Subscriptions = function (props) {
    var customerType = props.customerType, customerRole = props.customerRole;
    var crumbs = useAccountCrumbs([
        {
            label: 'Subscriptions',
            path: '/myaccount/ordersubscription',
        },
    ]);
    useEffect(function () {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = "".concat(OG_URL, "/").concat(MERCHANT_ID, "/msi.js");
        getOrderSubscriptionHMAC()
            .then(function (response) {
            var _a = response.data, ogTimestamp = _a.ogTimestamp, ogClientId = _a.ogClientId, ogHmacToken = _a.ogHmacToken;
            document.cookie = "og_auth=".concat(ogClientId, "|").concat(ogTimestamp, "|").concat(ogHmacToken, "; path=/; secure");
        })
            .catch(function (error) {
            // eslint-disable-next-line no-console
            console.debug('Error getting HMAC sub token', error);
        })
            .finally(function () {
            document.body.appendChild(script);
        });
        return function () {
            document.body.removeChild(script);
        };
    }, []);
    return (React.createElement(PageLayout, { crumbs: crumbs, pageTitle: "Subscriptions", customerRole: customerRole, customerType: customerType, internalRoutes: ['/myaccount/ordersubscription'] },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-max-w-[1039px]" },
            React.createElement("div", null,
                React.createElement("div", { className: "sui-p-[10px]" },
                    React.createElement(Typography, { variant: "h1", className: "sui-uppercase sui-font-extrabold" }, "Subscriptions")),
                React.createElement("div", { className: "sui-py-[10px] sui-px-[10px]" },
                    React.createElement(Typography, null, "You can manage, modify, and track all of your subscription orders below."))),
            React.createElement("div", { className: "sui-p-[10px] md:sui-width-[335px] sm:sui-width-[335px]" },
                React.createElement(Button, { variant: "primary", href: "https://www.homedepot.com/c/subscription_service?cm_sp=vanity-_-subscriptions-_-JAN19" },
                    React.createElement("span", { className: "sui-font-extrabold" }, "Shop Subscriptions"))),
            React.createElement("div", { id: "og-msi" }))));
};
Subscriptions.displayName = 'Subscriptions';
